export default {
    getTotalScore(state){
        return parseInt(state.no1) + parseInt(state.no2) + parseInt(state.no3) + parseInt(state.no4) + parseInt(state.no5) + parseInt(state.no6) + parseInt(state.no7) + parseInt(state.no8) + parseInt(state.no9) + parseInt(state.no10)
    }
};
